<template>
	<BaseInput
		v-growable="'value'"
		v-model="innerValue"
		class="base-number-input"
		type="number"
	/>
</template>

<script>
import growable from '@/directives/growable';
import BaseInput from './BaseInput.vue';

export default {
	name: 'BaseNumberInput',
	components: {
		BaseInput,
	},
	directives: {
		growable,
	},
	props: {
		value: {
			type: Number,
			default: () => 0,
		},
	},
	data() {
		return {
			innerValue: this.value,
		};
	},
	watch: {
		value(value) {
			this.innerValue = value;
		},
		innerValue(innerValue) {
			this.$emit('input', Number(innerValue));
		},
	},
	created() {
		this.innerValue = this.value;
	},
};
</script>

<style lang="stylus" scoped>
.base-number-input
	text-align center
</style>



// WEBPACK FOOTER //
// src/components/BaseNumberInput.vue